import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Header, Item, Panel } from '.'
import { PanelProps } from './panel'
import { HeaderProps } from './header'
import { ItemProps } from './item'
import {
  CustomSlidingTutorialProps,
  SlidingTutorialContent
} from './sliding-tutorial-content'
import { Button } from '@contrast-security-inc/design-system-buttons'
import attacksGridBlockedIcon from '../../../images/tutorial/attacksGridBlockedIcon.png'
import attacksGridDetailsIcon from '../../../images/tutorial/attacksGridDetailsIcon.png'
import attacksGridGraphIcon from '../../../images/tutorial/attacksGridGraphIcon.png'
import attacksGridShieldIcon from '../../../images/tutorial/attacksGridShieldIcon.png'

const itemsConfig: ItemProps[] = [
  {
    title: {
      id: 'title_protectSlidingTutorial_protectPortfolio',
      defaultMessage: 'Protect Your Portfolio'
    },
    description: {
      id: 'detail_protectSlidingTutorial_protectPortfolio',
      defaultMessage:
        'Contrast can identify and block attacks from within a running application. We can build defenses, analyze all requests, and report and block any attack it sees.'
    },
    imagePath: attacksGridBlockedIcon,
    circleIndicators: [
      {
        selector: '[tutorial-highlight="attacksPage"]',
        radius: 52,
        yOffset: -24,
        xOffset: -12
      },
      {
        selector: '[tutorial-highlight="attacksPageFreemiumIcon"]',
        radius: 52,
        yOffset: -24,
        xOffset: -21
      },
      {
        selector: '[tutorial-highlight="attacksPageFreemium"]',
        radius: 52,
        yOffset: -24,
        xOffset: -12
      }
    ]
  },
  {
    title: {
      id: 'title_protectSlidingTutorial_monitorAnalyze',
      defaultMessage: 'Analyze Attacks'
    },
    description: {
      id: 'detail_protectSlidingTutorial_monitorAnalyze',
      defaultMessage:
        'Get an overview of application security across your portfolio. As we report attacks, utilize filters to focus on those that are currently active, manual, or automated attacks.'
    },
    imagePath: attacksGridGraphIcon,
    circleIndicators: [
      {
        selector: '[tutorial-highlight="quickView"]',
        radius: 70,
        yOffset: -32,
        xOffset: -18
      }
    ]
  },
  {
    title: {
      id: 'title_protectSlidingTutorial_attackDetails',
      defaultMessage: 'Get Attack Details'
    },
    description: {
      id: 'detail_protectSlidingTutorial_attackDetails',
      defaultMessage:
        'Drill into any attacker IP to get a breakdown of the individual events with details about the suspicious activity along with attack values.'
    },
    imagePath: attacksGridDetailsIcon,
    circleIndicators: [
      {
        selector: '[tutorial-highlight="attacksTitle"]',
        radius: 80,
        yOffset: -68,
        xOffset: -32
      },
      {
        selector: '[tutorial-highlight="attacksSuppressedTitle"]',
        radius: 80,
        yOffset: -68,
        xOffset: -32
      }
    ]
  },
  {
    title: {
      id: 'title_protectSlidingTutorial_takeAction',
      defaultMessage: 'Take Action'
    },
    description: {
      id: 'detail_protectSlidingTutorial_takeAction',
      defaultMessage:
        'Contrast will help you customize and protect against attacks. You can blacklist IPs, suppress an attack, or configure the protect rule.'
    },
    imagePath: attacksGridShieldIcon,
    circleIndicators: [
      {
        selector: '[tutorial-highlight="attacksTitle"]',
        radius: 80,
        yOffset: -68,
        xOffset: -32
      },
      {
        selector: '[tutorial-highlight="attacksSuppressedTitle"]',
        radius: 80,
        yOffset: -68,
        xOffset: -32
      },
      {
        selector: '[tutorial-highlight="attacksApplicationTitle"]',
        radius: 60,
        yOffset: -50,
        xOffset: -32
      }
    ]
  }
]

const headerConfig: HeaderProps = {
  title: {
    id: 'title_protectSlidingTutorial_sayHello',
    defaultMessage: 'Say Hello to Protect'
  },
  subtitle: {
    id: 'detail_protectSlidingTutorial_identifyBlockAttacks',
    defaultMessage: 'Identify and block attacks in real time.'
  }
}

const panelConfig: PanelProps = {
  renderHeader: () => {
    return <Header {...headerConfig} />
  },
  renderBody: () =>
    itemsConfig.map((item, index) => <Item key={index} {...item} />),
  renderFooter: (renderFooterProps) => {
    return (
      <Button {...renderFooterProps}>
        <FormattedMessage id="action_gotIt_emphasis" defaultMessage="Got it!" />
      </Button>
    )
  }
}

export function ProtectSlidingTutorial(props: CustomSlidingTutorialProps) {
  return props.isVisible ? (
    <SlidingTutorialContent
      isOpen={props.isOpen}
      renderPanel={(renderPanelProps) => {
        return <Panel {...renderPanelProps} {...panelConfig} />
      }}
      tutorialKey={props.tutorialKey}
      orgUuid={props.orgUuid}
      yOffset={props.yOffset}
      zIndex={props.zIndex}
    />
  ) : null
}
